import { log } from "three/examples/jsm/nodes/Nodes.js";
import EventEmitter from "./EventEmitter.js";

export default class Time extends EventEmitter {
    constructor() {
        super()

        // Setup
        this.start = Date.now()
        this.current = this.start
        this.elapsed = 0
        this.delta = 16 // Bugs if 0

        window.requestAnimationFrame(() => { // This waits for a frame 
            this.tick()
        })
    }

    tick() {

        const currentTime = Date.now()
        this.delta = currentTime - this.current
        this.current = currentTime;
        this.elapsed = this.current - this.start

        this.trigger('tick')

        // console.log(this.elapsed);
        // console.log(currentTime);

        window.requestAnimationFrame(() => {
            this.tick()
        })
    }
}